module.exports = __webpack_public_path__ + "static/load-zoom-8d80f0cafe9d4a9abfef8d41e24af26f.jpg";